<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import VerticalDistanceElement from "../../components/pagesbuilder/elements/VerticalDistanceElement";

    export default {
        name: "PreviewVerticalDistanceElement",
        mixins: [PreviewElement,VerticalDistanceElement]
    }
</script>
